/**
 * used to determine if a feature flag should render an item based organization-specific flags
 */
export const featureFlagRenderItemWithOrg = (byOrgFlag, orgId) => {
  return !!byOrgFlag?.includes(orgId);
};

/**
 * used to determine if a feature flag should render an item based on global and organization-specific flags
 */
const featureFlagRenderItem = (globalFlag, byOrgFlag, orgId) => {
  if (globalFlag) return true;
  return featureFlagRenderItemWithOrg(byOrgFlag, orgId);
};

export default featureFlagRenderItem;
